<template>
  <transition v-if="this.currentStep >= 2" name="fade">
    <div class="panel panel-primary">
      <div @click="show = !show" class="panel-heading">
        2 - SIMULAÇÃO<span class="pull-right">
          <i style="font-size: 1.5em" :class="show ? 'fa fa-arrow-down' : 'fa fa-arrow-right'" aria-hidden="true"></i>
        </span>
      </div>
      <div v-if="show" class="panel-body">
        <div>
          <div class="row">
            <div class="col-md-3">
              <form-helper :inputVar="formPreSimulacao.consumoEnergia" :form="formPreSimulacao"
                :readonly="this.currentStep != 2" type="money" label="Consumo Médio de Energia"
                validationType="Negative" placeholder="0,00" />
            </div>

            <div class="col-md-3">
              <form-helper :inputVar="formPreSimulacao.consumoEnergiakwh" :form="formPreSimulacao"
                :readonly="this.currentStep != 2" type="number" label="Consumo Médio de Energia (kw/h)"
                validationType="Negative" placeholder="0,00" />
            </div>

            <div class="col-md-3">
              <form-helper :inputVar="formPreSimulacao.rendaMensal" :form="formPreSimulacao"
                :readonly="this.currentStep != 2" type="money" label="Renda Média Mensal" validationType="Negative"
                placeholder="0,00" />
            </div>

            <div class="col-md-3">
              <form-helper :inputVar="formPreSimulacao.laborCost" :form="formPreSimulacao"
                :readonly="this.currentStep != 2" type="money" label="Valor da instalação" validationType="Negative2"
                placeholder="0,00" />
            </div>
          </div>

          <div class="row">

            <div class="col-md-3">
              <button v-if="!loader && currentStep < 3" type="button" class="btn btn-primary"
                style="margin-bottom: 15px; width: 100%" @click="simularParcela">
                Simular
              </button>

              <Loader v-if="loader" style="margin-top: 20px; margin-left: 20px" />
            </div>
          </div>

          <div class="row" v-if="this.formSimulacao.valorParcela.value > 0">
            <div class="col-md-3">
              <form-helper :inputVar="formSimulacao.valor" :form="formSimulacao" type="money" :readonly="true"
                label="Valor para Financiar" placeholder="0,00" />
            </div>
            <div class="col-md-3">
              <form-helper :inputVar="formSimulacao.valor" :form="formSimulacao" type="money" :readonly="true"
                label="Valor Liberado" placeholder="0,00" />
            </div>
            <div class="col-xs-6 col-md-3">
              <form-helper :inputVar="formSimulacao.parcela" :disabled="this.currentStep != 2" :form="formSimulacao"
                label="Parcela" placeholder="Selecione a parcela" type="select" :options="optionsParcela" />
            </div>

            <div class="col-xs-6 col-md-3 hidden">
              <form-helper v-if="this.formSimulacao.valorParcela.value > 0" :inputVar="formSimulacao.valorParcela"
                :form="formSimulacao" type="money" :readonly="true" label="Valor Parcela" placeholder="0,00" />
            </div>
          </div>
          <div class="row" v-if="this.formSimulacao.valorParcela.value > 0" style="padding-bottom: 10px;">
            <div class="col-xs-12">
              <span style="color: red; font-weight: bold;">** Valor para Financiar = Valor dos Produtos + Valor da
                Instalação.</span>
            </div>
          </div>

          <button v-if="
            !loading &&
            currentStep < 3 &&
            formSimulacao.valorParcela.value > 0
          " aria-label="Próximo" style="margin-bottom: 0.5em" class="btn btn-primary" @click="nextStep()">
            Próximo <i class="fa fa-chevron-right"></i>
          </button>

          <Loader v-if="loading" style="margin-top: 20px; margin-left: 20px" />
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
@media (min-width: 992px) {
  .btn-simular {
    margin-top: 2.2em;
  }
}
</style>

<script>
import FormHelper from "@/components/partials/FormHelper.vue";
import SolAgoraService from "@/services/SolAgoraService";

const respostaPadraoErroGenerico =
  "Serviço indisponível, tente novamente mais tarde.";

export default {
  name: "SolAgoraStep2",
  props: {
    total: { type: Number, default: 0 },
    idProject: { type: String, default: "" },
    codigoPedido: { type: String, default: 0 },
    currentStep: { type: Number, default: 0 },
    token: { type: String, default: "" },
  },
  components: {
    FormHelper,
  },
  data() {
    return {
      formPreSimulacao: {
        consumoEnergia: new this.$formInput(true),
        consumoEnergiakwh: new this.$formInput(true),
        rendaMensal: new this.$formInput(true),
        laborCost: new this.$formInput(true),
        attemptSubmit: false,
      },
      formSimulacao: {
        valor: new this.$formInput(true),
        parcela: new this.$formInput(true),
        valorParcela: new this.$formInput(true),
        attemptSubmit: false,
      },
      show: true,
      loader: false,
      simulations: [],
      optionsParcela: [],
      loading: false,
    };
  },
  methods: {
    async simularParcela() {
      if (this.currentStep != 2) return;

      try {
        this.formSimulacao.valor.value =
          this.total + this.formPreSimulacao.laborCost.value;
        this.formSimulacao.valorParcela.value = 0;

        this.formPreSimulacao.attemptSubmit = true;
        if (this.formPreSimulacaoErrors !== 0) return;

        this.loader = true;
        const res = await SolAgoraService.Simulation({
          apiUrl: this.$apiUrl,
          token: this.token,
          idProject: this.idProject,
          price: this.total + this.formPreSimulacao.laborCost.value,
          consumerEnergyBill: this.formPreSimulacao.consumoEnergia.value,
          consumerEnergykwh: this.formPreSimulacao.consumoEnergiakwh.value,
          monthlyIncome: this.formPreSimulacao.rendaMensal.value,
        });

        if (!res) {
          swal({
            title: "Aviso",
            text: respostaPadraoErroGenerico,
            icon: "warning",
          });
          return;
        }

        if (res.message) {
          swal({
            title: "Aviso",
            text: res.message,
            icon: "warning",
          });
          return;
        }

        if (res.data.Parcelas && res.data.Parcelas.length) {
          this.simulations = res.data.Parcelas;

          let parcelas = res.data.Parcelas.filter(
            (x) => x.VlrParcela <= this.formPreSimulacao.consumoEnergia.value
          ).sort((x, y) => y.VlrParcela - x.VlrParcela);

          if (!parcelas.length)
            parcelas = res.data.Parcelas.sort(
              (x, y) => x.VlrParcela - y.VlrParcela
            );

          this.optionsParcela = res.data.Parcelas.map((x) => ({
            code: x.Prazo,
            label: `${x.Prazo} x R$ ${x.VlrParcela.toFixed(2).replace(
              ".",
              ","
            )}`,
          }));

          this.formSimulacao.parcela.value = {
            code: parcelas[0].Prazo,
            label: `${parcelas[0].Prazo} x R$ ${parcelas[0].VlrParcela.toFixed(
              2
            ).replace(".", ",")}`,
          };
          this.formSimulacao.valorParcela.value = parcelas[0].VlrParcela;
        }
      } finally {
        this.loader = false;
      }
    },

    async nextStep() {
      try {
        this.loading = true;

        // const pev_codigo = this.codigoPedido.toString().split("-")[0];
        // const res = await SolAgoraService.PreAnalysis({
        //   apiUrl: this.$apiUrl,
        //   token: this.token,
        //   idProject: this.idProject,
        //   codigoPedido: pev_codigo,
        // });

        // if (!res) {
        //   swal({
        //     title: "Aviso",
        //     text: respostaPadraoErroGenerico,
        //     icon: "warning",
        //   });
        //   return;
        // }

        // if (res.message) {
        //   swal({
        //     title: "Aviso",
        //     text: res.message,
        //     icon: "warning",
        //   });
        //   return;
        // }

        // if (!res.data.Approved) {
        //   swal({
        //     title: res.data.Message,
        //     icon: "warning",
        //   });
        //   return;
        // }

        const parcela = this.simulations.filter(
          (x) => x.Prazo == this.formSimulacao.parcela.value.code
        )[0];

        this.$emit("setResultadoSimulacao", {
          ...parcela,
          consumerEnergyBill: this.formPreSimulacao.consumoEnergia.value,
          monthlyIncome: this.formPreSimulacao.rendaMensal.value,
          laborCost: this.formPreSimulacao.laborCost.value,
        });
        this.$emit("next");
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    "formSimulacao.parcela.value": function (val) {
      if (val) {
        const parcela = this.simulations.filter((x) => x.Prazo == val.code)[0];
        this.formSimulacao.valorParcela.value = parcela.VlrParcela;
      }
    },
    "formPreSimulacao.consumoEnergia.value": function (val) {
      if (this.formSimulacao.valorParcela.value > 0)
        this.formSimulacao.valorParcela.value = 0;
    },
    "formPreSimulacao.rendaMensal.value": function (val) {
      if (this.formSimulacao.valorParcela.value > 0)
        this.formSimulacao.valorParcela.value = 0;
    },
    "formPreSimulacao.laborCost.value": function (val) {
      if (this.formSimulacao.valorParcela.value > 0)
        this.formSimulacao.valorParcela.value = 0;
    },
  },
  computed: {
    formPreSimulacaoErrors: function () {
      const errors = Object.keys(this.formPreSimulacao).filter(
        (key) =>
          this.formPreSimulacao[key].validation &&
          !this.formPreSimulacao[key].validation.status
      );
      return errors.length;
    },

    formSimulacaoErrors: function () {
      const errors = Object.keys(this.formSimulacao).filter(
        (key) =>
          this.formSimulacao[key].validation &&
          !this.formSimulacao[key].validation.status
      );
      return errors.length;
    },
  },
};
</script>